import { z } from "zod";

import { auditDate } from "@/schemas";

import { environmentalChecklistItemWithTicket } from "../../../../schemas";

export const moveInMoveOutLivingSchema = z.object({
  auditDate: auditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  livingDoor: environmentalChecklistItemWithTicket,
  livingWall: environmentalChecklistItemWithTicket,
  livingFloor: environmentalChecklistItemWithTicket,
  livingWindow: environmentalChecklistItemWithTicket,
});
